const constants = {
  LANGUAGES: [
    { key: 'en', label: 'English', short_label: 'EN' },
    { key: 'zh', label: '繁體中文', short_label: '中文' },
  ],
  LOCALE_LOCAL_STORAGE: 'pickupp-hk-landing-locale',
  FB_PIXEL_ID: '236549080193640',
  BING_ADS_ID: '56381234',
  PHONE_PATTERN: '^[0-9]{8}$',
  PICKUPP_INFO: {
    logo: 'https://assets.pickupp.io/strapi/pickupp_red_8baee5ea92.png',
    phone: '',
    address: {
      street_address: 'Room 412-413, Harbour Center Phase 1',
      address_locality: 'Hung Hom',
      postal_code: '0000',
    },
  },
}

module.exports = {
  local: {
    ...constants,
    S3_BUCKET: 's3://pickupp-dev-cloudfront/landing-dev',
    S3_REGION: 'ap-southeast-1',
    CLOUDFRONT_ID: 'E2I1EAT0SN13RL',
    MERCHANT_PORTAL: 'http://portal-dev.hk.pickupp.io',
    SITE_URL: 'http://localhost:3000',
    GTM_ID: 'GTM-TM87S9QK',
    SERVER_URL: 'http://localhost/v2',
    SOCKET_URL: 'ws://localhost/websocket',
  },
  development: {
    ...constants,
    S3_BUCKET: 's3://pickupp-dev-cloudfront/landing-dev',
    S3_REGION: 'ap-southeast-1',
    CLOUDFRONT_ID: 'E2I1EAT0SN13RL',
    MERCHANT_PORTAL: 'https://portal-dev.hk.pickupp.io',
    SITE_URL: 'https://landing-dev.pickupp.io',
    GTM_ID: 'GTM-TM87S9QK',
    SERVER_URL: 'https://gateway-dev.hk.pickupp.io/v2',
    SOCKET_URL: 'wss://gateway-dev.hk.pickupp.io/websocket',
  },
  uat: {
    ...constants,
    S3_BUCKET: 's3://pickupp-dev-cloudfront/landing-dev',
    S3_REGION: 'ap-southeast-1',
    CLOUDFRONT_ID: 'E2I1EAT0SN13RL',
    MERCHANT_PORTAL: 'https://portal-uat.hk.pickupp.io',
    SITE_URL: 'https://landing-uat.pickupp.io',
    GTM_ID: 'GTM-NZGW5R47',
    SERVER_URL: 'https://gateway-uat.hk.pickupp.io/v2',
    SOCKET_URL: 'wss://gateway-uat.hk.pickupp.io/websocket',
  },
  production: {
    ...constants,
    S3_BUCKET: 's3://hk.pickupp.io',
    S3_REGION: 'ap-northeast-1',
    CLOUDFRONT_ID: 'E1PSNQ1WVCEO5A',
    MERCHANT_PORTAL: 'https://portal.hk.pickupp.io',
    SITE_URL: 'https://hk.pickupp.io',
    GTM_ID: 'GTM-TMCTT92',
    SERVER_URL: 'https://gateway.hk.pickupp.io/v2',
    SOCKET_URL: 'wss://gateway.hk.pickupp.io/websocket',
    CHATWOOT_TOKEN: 'akVRfwgmo57Dh41CgmYPCGN3',
  },
}
